import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Sparkles } from "lucide-react";
import type { Certification } from "@/lib/certifications";

export function NsdcBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-primary/15 px-2.5 py-1 text-xs font-semibold text-primary">
      <BadgeCheck className="h-3.5 w-3.5" aria-hidden="true" /> NSDC approved
    </span>
  );
}

export function WekitBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-accent/15 px-2.5 py-1 text-xs font-semibold text-accent">
      <Sparkles className="h-3.5 w-3.5" aria-hidden="true" /> Recommended by WeKIT
    </span>
  );
}

export default function CertCard({
  cert, recommended = false, from,
}: { cert: Certification; recommended?: boolean; from?: string }) {
  return (
    <li className="glass-card lift flex h-full flex-col gap-3 rounded-3xl p-5">
      <div className="flex flex-wrap gap-2">
        <NsdcBadge />
        {recommended && <WekitBadge />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-foreground">{cert.name}</p>
        <p className="mt-1 text-sm text-muted-foreground">
          {cert.provider}
          {cert.level ? ` · ${cert.level}` : ""}
          {cert.nsqf ? ` · NSQF ${cert.nsqf}` : ""}
          {cert.duration ? ` · ${cert.duration}` : ""}
        </p>
      </div>
      <Link
        to={`/certifications/${cert.id}`}
        state={{ from, recommended }}
        className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-secondary px-4 text-sm font-semibold text-foreground hover:bg-secondary/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        View certification <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </li>
  );
}
